import React from "react";
import { fmtMoney, parseMoney } from "../lib/mw";

export const MoneyInput = ({ value, onChange, onBlur, ...rest }) => (
  <input {...rest} inputMode="decimal" value={fmtMoney(value)} onChange={(e) => onChange(parseMoney(e.target.value))} onBlur={onBlur ? () => onBlur(value) : undefined} />
);
